export default __webpack_public_path__ + "static/media/1_0058.9e05715c.webp";